import React from 'react';
import ReactDOM from 'react-dom';
import GlobalContext from 'src/context';
import App from './App';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <GlobalContext>
      <App />
    </GlobalContext>
  </React.StrictMode>
);
